import { render, staticRenderFns } from "./FaqCategoryTable.vue?vue&type=template&id=77c174ce&scoped=true"
import script from "./FaqCategoryTable.vue?vue&type=script&lang=js"
export * from "./FaqCategoryTable.vue?vue&type=script&lang=js"
import style0 from "./FaqCategoryTable.vue?vue&type=style&index=0&id=77c174ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c174ce",
  null
  
)

export default component.exports